import React from 'react'
import { Registry } from "@react-registry"

import { elementCategories } from "../elementCategories"
import Toggle from '../../../../../ToggleSwitch/ToggleSwitch'
import { useSlate } from 'slate-react'
import styles from './stye.module.css'

export default function ShowPropertiesBtn(props) {

    const editor = useSlate()
    const handleChange = (event) => {   
        const isShow = editor['showProperties'];
        (editor as any).dispatchShowProperties(!isShow)
    }

    return (
        <div
            className={styles['show-properties']}
            data-testid="show-properties"
            onMouseDown={handleChange}
        >
            <Toggle
                label='Show Properties'
                labelPosition='right'
                onChange={handleChange}
                checked={editor['showProperties']}
            />
        </div>
    )
}

Registry.register(
    {
        category: elementCategories.PROPERTY,
        toolbar: {
            inSlashToolbar: false,
            RenderComponent: ShowPropertiesBtn
        },
        title: 'Show Properties',
        canCustomize: false,
        isContentStackElement: true
    },
    { id: 'show-properties', registry: 'v2.element' }
)
